import { render, staticRenderFns } from "./AddClassifier.vue?vue&type=template&id=072f2db3&"
import script from "./AddClassifier.vue?vue&type=script&lang=js&"
export * from "./AddClassifier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports